import GoodsAction from '@/components/GoodsAction'
import RechargeAction from '@/components/GoodsAction/rechargeAction'
import { getUrlByPath } from '@/assets/js/utils'

export const namespaced = true

export const state = () => ({})

export const getters = {}

export const mutations = {}

export const actions = {
  /**
   * 打开商品导航
   * @param dispatch
   * @param {{setId?:number, goodsId?:number, orderId?:string}} params 参数
   */
  async openGoodsAction({ dispatch }, params) {
    const isLogin = await dispatch('auth/ensureLogin', undefined, {
      root: true
    })

    if (isLogin) {
      GoodsAction.show(params)
    }
  },
  /**
   * 打开充值导航
   * @param dispatch
   * @param {{setId?:number, goodsId?:number, orderId?:string}} params 参数
   */
  async openRechargeAction({ dispatch }, params) {
    const isLogin = await dispatch('auth/ensureLogin', undefined, {
      root: true
    })

    if (isLogin) {
      RechargeAction.show(params)
    }
  },

  /**
   * 打开收银台
   */
  open({ dispatch }, params) {
    return new Promise(resolve => {
      const orderId = params.orderId
      const method = params.payMethod
      const type = params.type
      const tradeType = params.tradeType

      const child = window.open(
        getUrlByPath('cashier-desk', {
          orderId,
          method,
          type,
          tradeType,
          callback: encodeURIComponent(location.href),
          name: (window.name = 'yktpc')
        })
      )

      child.onmessage = message => {
        if (message && typeof message.data === 'boolean') {
          if (message.data) {
            GoodsAction.hide()
          }

          if (params.callback) {
            params.callback(message.data)
          }
          resolve(message.data)
        }
      }
    })
  }
}
